import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = [...comics].sort(
    (a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime(),
  );

  return (
    <section className="py-14 md:py-20 bg-background-50" aria-label="最新更新">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-3">
            实时更新
          </span>
          <h2 className="text-2xl md:text-4xl font-display font-bold text-foreground-950">
            最新更新
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestComics.slice(0, 9).map((comic) => {
            const latestChapter = comic.chapters[comic.chapters.length - 1];
            return (
              <article
                key={comic.id}
                className="flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-background-100 transition-all duration-300"
              >
                <Link
                  to={`/comic/${comic.slug}`}
                  className="flex-shrink-0 w-20 h-28 rounded-md overflow-hidden"
                >
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 在线免费阅读`}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                </Link>
                <div className="flex flex-col justify-between flex-1 min-w-0">
                  <div>
                    <Link
                      to={`/comic/${comic.slug}`}
                      className="text-sm font-heading font-semibold text-foreground-900 hover:text-primary-600 transition-colors line-clamp-1"
                    >
                      {comic.title}
                    </Link>
                    <div className="flex items-center gap-2 mt-1 flex-wrap">
                      <span className="text-xs text-accent-600 flex items-center gap-0.5">
                        <i className="ri-star-fill w-3 h-3 flex items-center justify-center"></i>
                        {comic.rating}
                      </span>
                      <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700">
                        {comic.category}
                      </span>
                    </div>
                    {latestChapter && (
                      <p className="text-xs text-foreground-600 mt-2 line-clamp-1">
                        最新：{latestChapter.title}
                      </p>
                    )}
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-500">
                      {comic.updateTime}
                    </span>
                    <span className="text-xs text-foreground-400">
                      {comic.chapters.length}话
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 hover:bg-foreground-800 text-background-50 font-medium text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            查看更多更新
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}